<template>
  <b-container class="mt-5">
    <b-row>
      <b-col md="6">
        <img
          src="../assets/404.png"
          alt=""
        >
      </b-col>
      <b-col
        md="6"
        class="d-flex justify-content-center flex-column"
      >
        <h1 class="display-1">
          404
        </h1>
        <h2 class="display-4">
          UH OH! You're lost.
        </h2>
        <p>
          The page you are looking for does not exist.
          How you got here is a mystery. But you can click the button below
          to go back to the homepage.
        </p>
        <b-button
          variant="outline-dark"
          :to="{name: 'home'}"
        >
          HOME PAGE
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>
